import React, { useState, useRef, useEffect } from 'react'
import masterServices from '../../Services/masterService'
import { useHistory } from 'react-router'
import Loader from '../../Components/Loader'
import { useLocation } from 'react-router-dom'
import CheckAccess from '../../Function/CheckAccess'

export const Insurance = () => {
    const [loader, setLoader] = useState(false)
    const [data, setData] = useState([])
    const history = useHistory()
    const imgRef = useRef()

    const location = useLocation()
    let user_type = localStorage.getItem("user_type")

    useEffect(() => {
         getItemList()
    }, [])

    const getItemList = () => {
        masterServices.get_insurance().then(res => {
            console.log(res,'datadatadatadata')
            if (res.status) {
                setData(res.data)
                //setLoader(false)
               
            } else {
                history.goBack()
            }
        })
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-end mb-3">
                                {data && data.length <=0 && ((CheckAccess(214,"add")) ||  user_type === "SUPERADMIN") &&
                                <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('add-insurance')}
                            >Add Insurance</button>}

                            {data && data.length>0 && (CheckAccess(214,"edit") || user_type === "SUPERADMIN") &&
                            <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                            onClick={() => history.push('/edit-insurance?id=' + data[0]._id, data)}
                            >Edit Insurance</button>
                            }

                            <input ref={imgRef} type="file" className="d-none" />
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0 table-striped text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th>Insurance Premium (%)</th>
                                        <th>Min Aed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> {data.length && data[0].insurance_premium}</td>
                                        <td> {data.length && data[0].minimum_aed}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Loader isShow={loader} />
                </div>
            </div>
        </div>
    )
}
